<script>
import ElementsNotification from "@/components/elements/ElementsNotification.vue";
export default {
    components: {
        ElementsNotification,
    },
    name: "ErrorPopup",
    data() {
        return {
            showPopup: false,
            showMsg: "",
        };
    },
    created() {
        this.testpopup();
    },
    methods: {
        testpopup() {
            let self = this;

            self.$emitter.$on("UI_EVENT_LOADING_BG_OVERLAY", (status,errorCode) => {

                switch (true) {
                    case errorCode == "HR_FORGOT_ACCOUNT_FORBIDDEN_403_FAILED":
                        self.showMsg = "We couldn't find an account with that email address. Please check your email.";
                        break;
                    case errorCode == "HR_FORGOT_ACCOUNT_ALREADY_RESIGNED_500_FAILED":
                        self.showMsg = "This account is resigned. Password reset is not available.";
                        break;
                    case status == 400:
                        // error notification 관련 차차 없애나갈 예정 
                        // self.showMsg = "400 Bad Request error";
                        return;
                    case status == 409:
                        // 409 (Conflict)는 정상적인 비즈니스 검증 결과이므로 전역 팝업을 띄우지 않음
                        return;
                    case status == 401:
                        self.showMsg = "401 Unauthorized error";
                        break;
                    case status == 403:
                        self.showMsg = "403 Forbidden error";
                        break;
                    case status == 404:
                        self.showMsg = "404 Not Found error";
                        break;
                    case 500 > status && status > 400:
                        self.showMsg = "4xx Client error responses";
                        break;
                    case 600 > status && status >= 500:
                        // self.showMsg = "5xx Server error responses";
                        return;
                    default:
                        self.showMsg = "A network-related error occurred while connecting. Please try again and contact the support team if this issue persists.";
                }
                self.showPopup = true;
            });
        },
    },
};
</script>

<template>
    <Teleport to="body">
        <ElementsNotification
            v-model="showPopup"
            :notificationMsg="showMsg"
            :warning="showPopup"
        />
    </Teleport>
</template>
